// Single entry point for pushing Hubspot custom behavioral events.
// Components do not need to touch window._hsq directly — go through trackEvent
// (or the named helpers) so SSR guards, error handling, and event-name
// configuration stay in one place.
//

function eventName(internalName) {
    const portalId = process.env.GATSBY_HUBSPOT_PORTAL_ID;
    return portalId ? `pe${portalId}_${internalName}` : '';
}

// Hubspot date properties must be a Unix timestamp (ms) set to midnight UTC.
// Normalise the calendar date in UTC so the time-of-day is dropped.
function toHubspotDate(value) {
    if (!value) return undefined;
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return undefined;
    return Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
}

const EVENTS = {
    ORDER_PLACED: eventName('ecom_order'),
    QUOTE_PLACED: eventName('ecom_quote'),
};

export function identifyContact(email) {
    if (typeof window === 'undefined' || !email) return;
    try {
        window._hsq = window._hsq || [];
        window._hsq.push(['identify', { email }]);
    } catch (e) {
        // Prevent analytics from breaking FE.
    }
}

export function trackEvent(name, properties) {
    if (typeof window === 'undefined' || !name) return;
    try {
        window._hsq = window._hsq || [];
        window._hsq.push(['trackCustomBehavioralEvent', { name, properties: properties || {} }]);
    } catch (e) {
        // Prevent analytics from breaking FE.
    }
}

export const trackOrderPlaced = (order) => trackEvent(EVENTS.ORDER_PLACED, {
    purchase_qty: order?.purchase_qty,
    purchase_value: order?.purchase_value,
    purchase_skus: order?.purchase_skus,
    purchase_date_latest: toHubspotDate(order?.purchase_date_latest),
    purchase_count: order?.purchase_count,
    purchase_date_first: toHubspotDate(order?.purchase_date_first),
    promo_code: order?.promo_code,
    order_number: order?.order_number,
    c_number: order?.c_number,
});

export const trackQuotePlaced = (quote) => trackEvent(EVENTS.QUOTE_PLACED, {
    quote_no: quote?.quote_no,
    created_at: toHubspotDate(quote?.created_at),
    date_to: toHubspotDate(quote?.date_to),
    account_number: quote?.account_number,
    formatted_shipping_address: quote?.formatted_shipping_address,
    formatted_billing_address: quote?.formatted_billing_address,
    rows: quote?.rows ? JSON.stringify(quote.rows) : undefined,
    n_shipments: quote?.n_shipments,
    email: quote?.email,
    is_guest: quote?.is_guest,
    currency: quote?.currency,
    total: quote?.grand_total,
    quote_skus: quote?.quote_skus,
});
